// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, new-cap, babel/new-cap, default-param-last, babel/camelcase */
import { Map } from "immutable"
// FIXME: remove this disable directive and fix the ESLint error(s)
// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"
import type { Dispatch } from "redux"
import type Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import Price from "@kiwicom/frontend-common/records/Price"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import type { PassengerId, PriceTotal } from "@kiwicom/frontend-common/types/primitiveTypes"
import { bidSelector } from "@kiwicom/frontend-common/services/booking/booking"

import type { PassengerChanges } from "../../../../../../../services/bookings/bookingsApi"
import {
  deletePassengerEditRequestDetail,
  getPassengerEditRequestDetail,
  submitPassengerEditFrom,
} from "../../../../../../../services/bookings/bookingsApi"
import type { BookingId } from "../../../../../../../types/primitiveTypes"
import * as bookingActions from "../../../services/index"
import { getFileURIs } from "../../../../../../Booking/components/BookingFileUpload/BookingFileUploadHelpers"
import { handlePaymentRedirectAction } from "../../BookingPayment/services/actions/paymentActions"
import {
  bookingChangesSelector,
  currentBookingSpecificPassengerSelector,
} from "../../../services/selector"
import { compareUsers, formatDate, formatUser } from "./helpers"
import { DATE_FORMAT, EDITING_STEPS } from "../components/constants"
import type { ActivePaxRequestsIds } from "./PassengerChangesTypes"
import type {
  ActionWithoutPayload,
  ActionWithPayload,
  EditingStepProps,
  PassengerEdit,
  Stage,
  State,
} from "./types"
import {
  CLEAR_USER_EDITING,
  DELETE_CORRECTION,
  PAX_EDIT_STATUS,
  SET_NEW_PASSENGER_DATA,
  SET_PASSENGER_EDIT_STEP,
  SHOW_PAX_EDIT_OFFER,
  SHOW_PAX_EDIT_OFFER_FROM_LOADING,
  SUBMIT_EDIT_USER_FORM,
  TOGGLE_LEAVE_CONFIRMATION_PASSENGER_EDIT,
  TOGGLE_LOADING,
  TOGGLE_PASSENGER_EDIT,
} from "./consts"
import { ACTION } from "../../../services/consts"
import { closeModalAction } from "../../../services/bookingActions"
import { SERVICES } from "../../../../../../../consts/additionalServices"
import type { ShoppingBasketOutbound } from "../../BookingPayment/services/api/types"
import maybeConvertPrice from "@kiwicom/frontend-common/services/price/maybeConvertPrice"
import {
  convertPriceSelector,
  currencySelector,
} from "@kiwicom/frontend-common/services/currencies/selectors"
import mmbTrack from "../../../../../../../services/tracking/mmbTrack"
import {
  GeneralModule,
  InvalidDataReceiveAction,
} from "../../../../../../../services/tracking/constants/trackingEvents"

const initialState: State = Map({
  loading: false,
  user: {},
  newUserData: {},
  step: EDITING_STEPS.SELECTION,
  leaveConfirmationOpen: false,
  changePrice: 0,
  changeId: null,
  stage: "none",
})

export default function passengerEditReducer(
  state: State | null | undefined = initialState,
  action: ActionWithPayload | ActionWithoutPayload,
) {
  switch (action.type) {
    case TOGGLE_PASSENGER_EDIT:
      return state.set("user", action.payload).set("step", EDITING_STEPS.FORM)
    case SHOW_PAX_EDIT_OFFER:
      return state
        .set("user", action.payload.prev)
        .set("newUserData", action.payload.after)
        .set("changeId", action.payload.id)
        .set("changePrice", action.payload.price || 0)
        .set("step", EDITING_STEPS.SUMMARY_OFFER)
    case SHOW_PAX_EDIT_OFFER_FROM_LOADING:
      return state
        .set("changeId", action.payload.id)
        .set("changePrice", action.payload.price || 0)
        .set("step", EDITING_STEPS.SUMMARY)
        .set("loading", false)
        .set("stage", action.payload.stage)
    case SET_PASSENGER_EDIT_STEP:
      return state
        .set("step", action.payload.step)
        .set("stage", action.payload?.stage || state.get("stage"))
    case SET_NEW_PASSENGER_DATA:
      return state.set("newUserData", action.payload)
    case TOGGLE_LOADING:
      return state.set("loading", action.payload)
    case TOGGLE_LEAVE_CONFIRMATION_PASSENGER_EDIT:
      return state.set("leaveConfirmationOpen", !state.get("leaveConfirmationOpen"))
    case CLEAR_USER_EDITING:
      return state.merge(state, initialState)
    default:
      return state
  }
}

export const currentlyEditingUserSelector = (state: State) => state.passengerEdit.get("user")
export const editingStepSelector = (state: State) => state.passengerEdit.get("step")
export const editPriceSelector = (state: State) => state.passengerEdit.get("changePrice")
export const changeIdSelector = (state: State) => state.passengerEdit.get("changeId")
export const editedUserDataSelector = (state: State) => state.passengerEdit.get("newUserData")
export const passengerEditStageSelector = (state: State): Stage => state.passengerEdit.get("stage")
export const paxIdsWithActiveRequestSelector = (state: State): ActivePaxRequestsIds => {
  return (
    state.booking
      .get("data")
      // @ts-expect-error: Flow to TS migration.
      .bookingChanges.filter((c) => c.stage !== PAX_EDIT_STATUS.COMPLETED)
      // @ts-expect-error: Flow to TS migration.
      .map((c) => c.passenger_ids[0])
  )
}

export const setPassengerToState = (payload: Passenger) => ({
  type: TOGGLE_PASSENGER_EDIT,
  payload,
})

export const destroyPassengerEditForm = () => ({
  type: "redux-form/DESTROY",
  form: "editPassenger",
})

const toggleLoading = (payload: boolean) => ({
  type: TOGGLE_LOADING,
  payload,
})

export const setNewUserData = (data: PassengerEdit) => ({
  type: SET_NEW_PASSENGER_DATA,
  payload: {
    ...data,
    birth: formatDate(data.birth),
    document: {
      code: data.document.code,
      expiration: formatDate(data.document.expiration),
    },
  },
})

export const showPassengerEditOfferAction = (
  after: PassengerEdit,
  prev: Passenger,
  price: PriceTotal,
  id: number,
) => ({
  type: SHOW_PAX_EDIT_OFFER,
  payload: { after, prev, price, id },
})

export const showOfferFromLoading = (price: PriceTotal, id: number, stage: Stage) => ({
  type: SHOW_PAX_EDIT_OFFER_FROM_LOADING,
  payload: { price, id, stage },
})

export const setStep = ({ step, stage }: { step: EditingStepProps; stage?: Stage }) => ({
  type: SET_PASSENGER_EDIT_STEP,
  payload: {
    step,
    stage,
  },
})

export const clearUserEditing = () => ({
  type: CLEAR_USER_EDITING,
})

// Transform data for redux form
export const setPassenger = (paxId: PassengerId) => (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  getState: () => State,
) => {
  let pax = currentBookingSpecificPassengerSelector(getState(), paxId)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!pax) {
    mmbTrack(
      {
        module: GeneralModule,
        action: InvalidDataReceiveAction,
        detail: "unknown passenger ID in setPassenger",
      },
      { paxId },
    )

    return
  }

  // @ts-expect-error: Flow to TS migration.
  pax = { ...pax }
  // @ts-expect-error: Flow to TS migration.
  pax.birth = pax.birth.format(DATE_FORMAT)

  pax = fp.set(
    "document.expiration",
    pax.document.code && !pax.document.expiration ? "no-expiration" : pax.document.expiration,
    pax,
  )

  dispatch(setPassengerToState(pax))

  cuckoo.track(cuckooEvents.PAX_CHANGE_FORM_OPENED, { passengerId: paxId })
}

export const submitPassengerEditForm = (data: PassengerEdit) => async (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  getState: () => State,
) => {
  dispatch(setNewUserData(data))
  dispatch(toggleLoading(true))

  const state = getState()
  const formData = editedUserDataSelector(state)
  const user = currentlyEditingUserSelector(state)

  const newUserData = formatUser(formData)
  const oldUserData = formatUser(user)
  const compared = compareUsers(newUserData, oldUserData)

  const fileURIs = await getFileURIs(formData.files)
  const payload: PassengerChanges = {
    passenger_changes: {
      [user.id]: { ...compared, files: fileURIs },
    },
  }

  cuckoo.track(cuckooEvents.PAX_CHANGE_FORM_SUBMIT, { passengerId: user.id, changes: compared })

  const bid = bidSelector(state)
  const promise = submitPassengerEditFrom(bid, payload)
  const changedFields = Object.keys(compared)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: ACTION,
    action: SUBMIT_EDIT_USER_FORM,
    promise,
    _track: { data: changedFields },
    bid,
    payload,
  })

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ok) {
    return promise.then((res) => {
      function callRequestDetail(retryCount: number) {
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        getPassengerEditRequestDetail(bid, res.id).then(({ id, price_amount, stage }) => {
          if (stage === PAX_EDIT_STATUS.DETERMINED) {
            cuckoo.track(cuckooEvents.PAX_CHANGE_OFFER, {
              type: "Auto",
              offeredPrice: price_amount,
            })

            dispatch(showOfferFromLoading(price_amount, id, stage))
          } else if (retryCount === 3 || stage === PAX_EDIT_STATUS.BACKOFFICE) {
            dispatch(toggleLoading(false))
            dispatch(setStep({ step: EDITING_STEPS.THANK_YOU, stage }))

            cuckoo.track(cuckooEvents.PAX_CHANGE_OFFER, { type: "Manual" })
          } else {
            setTimeout(() => {
              callRequestDetail(retryCount + 1)
            }, 5000)
          }
        })
      }

      callRequestDetail(0)
    })
  }
  dispatch(toggleLoading(false))
  dispatch(setStep({ step: EDITING_STEPS.ERROR, stage: "none" }))

  return ok
}

export const toggleConfirmationModal = () => ({
  type: TOGGLE_LEAVE_CONFIRMATION_PASSENGER_EDIT,
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const closePassengerEditModal = () => (dispatch: Dispatch<any>, getState: () => State) => {
  const state = getState()
  const editingStep = editingStepSelector(state)

  switch (editingStep) {
    case EDITING_STEPS.SUMMARY:
      return dispatch(toggleConfirmationModal())
    case EDITING_STEPS.THANK_YOU:
    case EDITING_STEPS.ERROR:
      dispatch(bookingActions.reloadBooking(bidSelector(state)))
      break
    default:
  }
  return dispatch(closeModalAction())
}

// Cancel whole request from confirmation modal (Phase 02)
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cancelEditRequest = () => (dispatch: Dispatch<any>) => {
  dispatch(closeModalAction())
  dispatch(clearUserEditing)
}

export const deletePassengerEditRequestById = (bid: BookingId, requestId: number) => async (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
) => {
  const promise = deletePassengerEditRequestDetail(bid, requestId)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: DELETE_CORRECTION,
    action: DELETE_CORRECTION,
    promise,
  })

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ok) {
    // @ts-expect-error: Flow to TS migration.
    return promise.catch((err) => err).then(dispatch(closeModalAction()))
  }
  return ok
}

/**
 * This function handles two kinds of payloads for the shopping basket.
 *
 * Passenger change created via MMB.
 *
 * @returns {function(Dispatch<*>, function(): State): *}
 */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toPayment = () => (dispatch: Dispatch<any>, getState: () => State) => {
  const state = getState()
  const currency = currencySelector(state)
  const convertPrice = convertPriceSelector(state)
  // This amount we got in the submitPassengerEditForm action.
  const editPrice = editPriceSelector(state)

  const passengerChangeRequestId = changeIdSelector(state)

  // we don't have unpaidPassengerChangeRequest
  // This is information from main MMB call
  const unpaidPassengerChangeRequest = bookingChangesSelector(state)?.find(
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (bookingRequest: any) => bookingRequest.id === passengerChangeRequestId,
  )

  const determinedPrice = new Price({
    amount: unpaidPassengerChangeRequest ? unpaidPassengerChangeRequest.price_amount : editPrice,
  })

  const price = maybeConvertPrice(currency, convertPrice, determinedPrice)

  const passengerChangeShoppingBasketPayload: ShoppingBasketOutbound = {
    currency: currency.toUpperCase(),
    items: {
      passenger_details_change: [
        {
          price: Price.toServer(price),
          passenger_change_request_id: passengerChangeRequestId,
        },
      ],
    },
  }

  return dispatch(
    // @ts-expect-error: Flow to TS migration.
    handlePaymentRedirectAction(passengerChangeShoppingBasketPayload, SERVICES.PASSENGER_EDIT),
  )
}
